module.exports = __webpack_public_path__ + "static/media/how-it-works-landlord-1.3182e9b7.svg";